import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";

export const useDeactivate = () => {
  const dispatch = useDispatch();
  const { navigateToTopPage } = useNavigation();

  const handleDeactivate = useCallback((email: string, password: string) => {
    dispatch(
      appActions.showModal.started({
        title: "本当に退会しますか？",
        closeButtonLabel: "閉じる",
        nextButtonLabel: "退会",
        handleClose: () => dispatch(appActions.closeModal()),
        handleNext: () => {
          dispatch(appActions.showLoading());
          dispatch(
            authActions.deactivate.started({
              login_id: email,
              password,
              // TODO: change to selected language
              lang: "ja",
              onComplete: () => dispatch(appActions.hideLoading()),
              onSuccess: () => {
                dispatch(
                  appActions.showModal.started({
                    title: "退会しました。",
                    subTitle: "ご利用ありがとうございました。",
                    nextButtonLabel: "閉じる",
                    handleNext: () => dispatch(appActions.closeModal()),
                  }),
                );
                navigateToTopPage();
              },
            }),
          );
        },
      }),
    );
  }, []);

  return { handleDeactivate };
};
